<template>
  <div
    class="empty-withdrawal-widget"
    data-test-id="empty-withdrawal-widget"
  >
    <md-icon data-test-id="empty-withdrawal-widget-icon">
      credit_card
    </md-icon>
    <p data-test-id="empty-withdrawal-widget-msg1">
      {{ i18n.withdraw_no_assets() }}
    </p>
    <p data-test-id="empty-withdrawal-widget-msg2">
      {{ i18n.withdraw_no_assets_exp() }}
    </p>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'

  export default {
    name: 'EmptyWidgetStub',
    data: _ => ({
      i18n
    })
  }
</script>

<style lang="scss" scoped>
.empty-withdrawal-widget {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 20px;

  .md-icon {
    margin: 0;
    font-size: 80px !important;
    margin-bottom: 20px;
  }

  p {
    font-size: 16px;
    text-align: center;
    font-weight: 500;

    &:first-of-type {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/widgets/WithdrawalWidget/EmptyWidgetStub.vue